import React from 'react';
import styled from 'styled-components';
import Typography from 'components/Typography';
import { useResizeDetector } from 'react-resize-detector';
import Spacer from 'components/Spacer';
// import { GatsbyImage } from 'gatsby-plugin-image';
import ToggleButton from 'components/ToggleButton';
import SafeHtml from 'lib/components/SafeHtml';
import { AccordionItem } from './types';

interface Props extends AccordionItem {
  active: boolean,
  onClick: (id: string | null) => void,
}

const Item:React.FC<Props> = ({
  id,
  title,
  contentHTML,
  // icon,
  active,
  onClick,
}) => {
  const handleTitleClick = () => onClick(active ? null : id);
  const handleContentClick = () => onClick(null);
  const { height: innerContentHeight, ref } = useResizeDetector();
  return (
    <ItemOuter className={active ? 'active' : ''}>
      <TitleButton type="button" onClick={handleTitleClick}>
        <IconTypeGroup>
          {/* {icon && (
            <TitleIconWrap>
              <GatsbyImage image={icon} alt={`${title} icon`} />
            </TitleIconWrap>
          )} */}
          <Typography variant="h6" as="p">{title}</Typography>
        </IconTypeGroup>
        <ToggleButton isOpen={active} />
      </TitleButton>

      <ContentWrap
        onClick={handleContentClick}
        innerContentHeight={innerContentHeight || 0}
        $active={active}
      >
        <ContentWrapInner ref={ref}>
          <Spacer p={2}>
            <SafeHtml html={contentHTML} />
          </Spacer>
        </ContentWrapInner>
      </ContentWrap>
    </ItemOuter>
  );
};
export default Item;

const ItemOuter = styled.div``;
const TitleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  text-align: left;
  border: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: transparent;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.primary};
`;
const IconTypeGroup = styled.div`
  display: flex;
  align-items: center;
`;
// const TitleIconWrap = styled.div`
//   margin-right: 0.5em;
// `;
interface ContentWrapProps {
  innerContentHeight: number,
  $active: boolean,
}
const ContentWrap = styled.div.attrs<ContentWrapProps>(({ $active, innerContentHeight }) => {
  const height = $active ? innerContentHeight : undefined;
  return { style: { height } };
})<ContentWrapProps>`
  overflow: hidden;
  height: 0;
  transition: height 0.3s;
  transition-timing-function: cubic-bezier(0.23, 1, 0.320, 1);
`;
const ContentWrapInner = styled.div``;
